import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { isSupabaseConfigured } from '@/config';
import { useAuth } from '@/lib/auth/AuthProvider';
import { getLivePredictionStats, submitLivePrediction } from '@/lib/data/provider';

/** Community split + my open "who scores next?" pick. Polls while the match is live. */
export function useLivePredictionStats(fixtureId: string, live: boolean) {
  const { userId } = useAuth();
  return useQuery({
    queryKey: ['live-predict', 'stats', fixtureId, userId ?? 'anon'],
    queryFn: () => getLivePredictionStats(fixtureId),
    enabled: isSupabaseConfigured && live,
    refetchInterval: live ? 20000 : false,
  });
}

export function useSubmitLivePrediction(fixtureId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (pick: 'home' | 'away') => submitLivePrediction(fixtureId, pick),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['live-predict', 'stats', fixtureId] }),
  });
}
